import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackClientEvent } from 'analytics/analytics'

const LIST_NAME = 'room_availability_strip'

/**
 * Fired once when the alternative-dates strip (shown on single-unit properties when the
 * selected dates are sold out) scrolls into view.
 */
export function trackRoomAvailabilityStripImpression(listInstance: string): void {
  trackClientEvent({
    subject: 'room_availability_strip',
    action: 'impression',
    category: 'offer_page',
    type: 'nonInteraction',
    context: [
      comluxgroup.createListItem_1_0_0({
        listName: LIST_NAME,
        listInstance,
        itemPosition: 1,
      }),
    ],
  })
}

/**
 * Fired when the customer selects an available alternative date from the strip.
 * `daysFromOriginalCheckIn` is the selected date's offset (in days, signed) from the customer's
 * originally selected check-in — not its position within the currently visible page, since that
 * would reset to the same small numbers regardless of how far the customer paged. The direction
 * is encoded in `listName` (forward/backward) so `itemPosition` itself can stay a non-negative
 * magnitude, matching the schema's plain "position on the list" semantics.
 */
export function trackRoomAvailabilityStripDateSelected(listInstance: string, daysFromOriginalCheckIn: number): void {
  const listName = daysFromOriginalCheckIn < 0 ? `${LIST_NAME}_backward` : `${LIST_NAME}_forward`

  trackClientEvent({
    subject: 'room_availability_strip',
    action: 'date_selected',
    category: 'offer_page',
    type: 'interaction',
    context: [
      comluxgroup.createListItem_1_0_0({
        listName,
        listInstance,
        itemPosition: Math.abs(daysFromOriginalCheckIn),
      }),
    ],
  })
}
